var link_viewer_default = {
  "fontElementMap": "xNs1l",
  "link": "infec",
  "linkInEditor": "FOFuF",
  "linkInViewer": "_5kGcG",
  "toolbarUrlContainer": "wRQWG",
  "toolbarUrl": "_3CeTT",
  "toolbarUrlAnchor": "c-q65"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
